// extracted by mini-css-extract-plugin
export default {"badge":"TiltedBadge_badge__6X9GL","badge_variant_brand":"TiltedBadge_badge_variant_brand__rpqLu","badge_variant_primary":"TiltedBadge_badge_variant_primary__Zw3SS"};